import React from "react";

export default function HouseIcon({ color = "currentColor" }) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 36 36"
      fill="none"
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.3474 15.9891C34.5889 15.9891 35.1072 14.394 34.0988 13.6587L18.7546 2.4971C18.5354 2.33655 18.2709 2.25 17.9992 2.25C17.7276 2.25 17.463 2.33655 17.2438 2.4971L1.89965 13.6587C0.891167 14.39 1.40947 15.9891 2.65501 15.9891H5.14206V31.0159H2.2492C2.07242 31.0159 1.92777 31.1605 1.92777 31.3373V33.4266C1.92777 33.6034 2.07242 33.748 2.2492 33.748H33.7492C33.926 33.748 34.0706 33.6034 34.0706 33.4266V31.3373C34.0706 31.1605 33.926 31.0159 33.7492 31.0159H30.8563V15.9891H33.3474ZM17.9992 5.32969L28.8916 13.2529H7.10679L17.9992 5.32969ZM8.03492 15.9891H12.7358V31.0159H8.03492V15.9891ZM15.6287 15.9891H20.3296V31.0159H15.6287V15.9891ZM27.9635 31.0159H23.2224V15.9891H27.9635V31.0159Z"
        fill="#fff"
        fillOpacity="0.85"
      />
    </svg>
  );
}
